import { useEffect, useRef } from 'react'

export const CHECKIN_UPDATED_KEY = 'checkinUpdated'

/**
 * tablet-register タブが閉じられた後に、親タブでチェックイン情報の更新を検知するための hook。
 * localStorage の storage イベントを利用してタブ間で変更通知を受け取る。
 *
 * useRef でコールバックを最新に保つことで、useEffect の依存配列を空にしつつ
 * 常に最新の onUpdate 関数を呼び出せるようにしている。
 */
export const useCheckinUpdatedListener = (onUpdate: () => void) => {
  const onUpdateRef = useRef(onUpdate)
  onUpdateRef.current = onUpdate

  useEffect(() => {
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === CHECKIN_UPDATED_KEY && e.newValue) {
        onUpdateRef.current()
        localStorage.removeItem(CHECKIN_UPDATED_KEY)
      }
    }

    window.addEventListener('storage', handleStorageChange)
    return () => window.removeEventListener('storage', handleStorageChange)
  }, [])
}
